module.exports = __webpack_public_path__ + "img/image7@3x.5ac6bab0.png";